import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = {
    postId: Number,
    scrollable: { type: Boolean, default: false }
  }

  connect () {
    if (!this.postToScroll) { return }
    if (!this.scrollableValue) { return }

    setTimeout(() => {
      this.scrollToPost()
      this.highlightPost()
    }, 1000)
  }

  scrollToPost () {
    window.scrollTo({
      top: this.postToScroll.offsetTop - 50,
      behavior: 'smooth'
    })
  }

  highlightPost () {
    this.postToScroll.querySelector('.card').classList.add('highlighted')
  }

  get postToScroll() {
    return this.element.querySelector(`[data-id="${this.postIdValue}"]`)
  }
}
